import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {getMessageFromException} from '../utilities/Util';
import {NotificationService} from './NotificationService';
import {Efs, EfsAssistanceClient} from './api.client';
import {Observable} from 'rxjs';

// 003-retire-ngrx (US2): the efs slice went component-local. EFS is a dead /
// historical section with a single consumer (ClientEfsComponent), which owns
// the list and the current selection now; the service just returns the shared
// API requests and keeps the user-facing notifications.
@Injectable()
export class EfsService {

  constructor(private _efsApiService: EfsAssistanceClient,
              private _notificationService: NotificationService) {
  }

  getCurrentClientEfsList(id: string, year: string): Observable<Efs[]> {
    const request = this._efsApiService.retrieveClientsEfsAssistances(id, year).pipe(share());
    request.subscribe({ error: () => {
      this._notificationService.showError('There was a problem retrieving the client\'s EFS.');
    }});
    return request;
  }

  addEfs(efs: Efs): Observable<Efs> {
    const request = this._efsApiService.addEfsAssistance(efs).pipe(share());
    this._notificationService.showSuccess('Attempting to save new EFS.');
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('Efs Successfully Created!');
    }, error: (err) => {
        this._notificationService.showError(getMessageFromException(err));
    }, complete: () => {

    }});
    return request;
  }

  updateEfs(efs: Efs): Observable<Efs> {
    const request = this._efsApiService.updateEfsAssistance(efs).pipe(share());
    this._notificationService.showSuccess('Attempting to update EFS.');
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('EFS Successfully Updated!');
    }, error: () => {
      this._notificationService.showError('There was a problem updating this EFS.');
    }, complete: () => {

    }});
    return request;
  }

  deleteEfs(id: string): Observable<boolean> {
    const request = this._efsApiService.deleteEfs(id).pipe(share());
    this._notificationService.showSuccess('Attempting to delete EFS.');
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('EFS Successfully Deleted!');
    }, error: () => {
      this._notificationService.showError('There was a problem deleting this EFS');
    }, complete: () => {

    }});
    return request;
  }
}
